<template>
    <section class="body-container">

        <!-- <section class="filter-container">
            <div class="content-max-width flex flex-between">
                <h4>Filter by</h4>
                <div class="filters flex">
                    <div class="date flex align-center">
                        <input 
                          placeholder="Start date" 
                          v-model="payload.startDate" 
                          class="textbox-n" 
                          type="text" 
                          @change="filter"
                          onfocus="(this.type='date')">
                        <img src="/images/to.svg" alt="" class="to">
                        <input 
                          placeholder="End date" 
                          v-model="payload.endDate" 
                          class="textbox-n" 
                          type="text" 
                          @change="filter"
                          onfocus="(this.type='date')">
                    </div>
                    <div class="location">
                        <select v-model="payload.location" @change="filter">
                            <option value>All</option>
                            <option v-for="location of locations" :key="location.name" :value="location.name" >{{ location.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </section> -->

        <div class="content-max-width">
            <div class="cards flex flex-between">
                <a v-for="item in articles" :key="item.id" :href="item.url" class="card">
                    <div class="image">
                        <div class="content">
                            <img :src="item.image" alt="">
                        </div>
                    </div>
                    <div class="content">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.published_date }}</p>
                        <p class="read-more">Read More</p>
                    </div>
                </a>
            </div>
            <button v-if="next" type="button" class="load-more button" @click="loadMore">Load More +</button>
        </div>
    </section>
</template>

<script>
export default {
  props: {
    url: String,
    locations: Array,
  },
  data () {
    return {
      links: [],
      articles: [],
      next: "",
      payload: {
        location: '',
        startDate: null,
        endDate: null,
      }
    }
  },
    computed: {
      filterItem() {
          console.log(this.selectedLocation, this.articles)
        let filterType = this.selectedLocation;
        let startDate = this.localizeDate(this.startDate);
        let endDate = this.localizeDate(this.endDate);

         const itemsByLocation = filterType ? this.articles.filter(item => item.location === filterType) : this.articles

         return itemsByLocation
                .filter(item => {
         const itemDate = new Date(item.date)

         if (startDate && endDate) {
            return startDate <= itemDate && itemDate <= endDate;
          }

          if (startDate && !endDate) {
            return startDate <= itemDate;
          }

          if (!startDate && endDate) {
            return itemDate <= endDate;
          }
        return true;
      })
    }
  },
  mounted() {
      axios.get(this.url).then(response => {
        this.articles = response.data.data
        this.next = response.data.links.next
      })
  },

  methods: {
    loadMore () {
      let url = this.next
      url += "&location=" + this.payload.location

      if (this.payload.startDate !== null) {
        url += "&startDate=" + this.payload.startDate
      }

      if (this.payload.endDate !== null) {
        url += "&endDate=" + this.payload.endDate
      }
      axios.get(url).then(response => {
        this.articles = this.articles.concat(response.data.data)
        this.next = response.data.links.next
      })
    },

    localizeDate(date) {
      // Date picker uses ISO format (yyyy-mm-dd), which is UTC. The data
      // contains locale specific date strings (mm/dd/yyyy), which `Date`
      // parses with local time-zone offset instead of UTC. Normalize the
      // ISO date so we're comparing local times.
      if (!date || !date.includes('-')) return date
      const [yyyy, mm, dd] = date.split('-')
      return new Date(`${mm}/${dd}/${yyyy}`)
    },
    formatDate(date) {
      return new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date))
    },

    filter () {
      this.articles = [];
      let url = this.url + "?"
      url += "location=" + this.payload.location

      if (this.payload.startDate !== null) {
        url += "&startDate=" + this.payload.startDate
      }

      if (this.payload.endDate !== null) {
        url += "&endDate=" + this.payload.endDate
      }

      axios.get(url).then(response => {
        this.articles = response.data.data
        this.next = response.data.links.next
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/WhatsOn.vue